module.exports = __webpack_public_path__ + "static/media/36.608aca9c.png";